module.exports = __webpack_public_path__ + "img/rightside_1000.92d25340.png";